import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f82e808"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-up-square" }, null, -1))

import { onMounted, onUnmounted, ref } from 'vue';
import { scrollIntoViewByClass } from '@/Utils/Common';
import { debounce } from "@/Utils/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'BackTop',
  setup(__props) {

const showBackTop = ref<boolean>(false); // 是否显示回到顶部的提示按钮

const backTop = () => { // 监听返回顶部按钮是否显示 
  const scrollTop = document.documentElement.scrollTop; //scrollTop是浏览器滚动条的top位置
  if (scrollTop > 300) { showBackTop.value = true; }
  else { showBackTop.value = false; }
}

const debounceBackTop = debounce(backTop, 200, true) // 添加滚动加载防抖


onMounted(async () => {
  window.addEventListener("scroll", debounceBackTop);
});
onUnmounted(() => { // 组件销毁时
  window.removeEventListener('scroll', debounceBackTop); // 销毁返回顶部监听
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "back-top",
    style: _normalizeStyle(showBackTop.value ? { opacity: '1' } : ''),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(scrollIntoViewByClass)('bocatrip-app')))
  }, [
    _hoisted_1,
    _createTextVNode("顶部 ")
  ], 4))
}
}

})